import React from "react";
import { NumericTextBox } from '@progress/kendo-react-inputs';
import {InlineCellProps, KendoNumericTextBoxProps} from './CustomProps';
import { NumberFormatOptions } from "@telerik/kendo-intl";
const NumericCell: React.FC<KendoNumericTextBoxProps> = ({max, numberFormat, dataItem, field,required, className,style, onChange,  ...props}) =>{
    const handleChange = (e: any) => {
		const item = { ...dataItem, [field!]: e.target.value };
		onChange!({
			...props,
			dataItem: item,
			syntheticEvent: e.syntheticEvent,
			field: field,
			value: e.target.value,
		});
	}
    return (
        <td style={style}  className={className} >
            {
                dataItem.inEdit ? (
                    <NumericTextBox
                        required={required}
                        value={dataItem[field!]}
                        onChange={handleChange}
                        format={numberFormat}
                        min={1}
                        max={max}
                    />
                ) : (<span style={style}> { dataItem[field!] } </span>) 
            }
        </td>
    )
}

export default NumericCell;